import IconConstants from "@/lib/iconConstants";
import JobWorkerInterviewType from "@/models/JobWorkerInterviews/JobWorkerInterviewType";

export default (value: JobWorkerInterviewType) => {
    switch (value) {
        case JobWorkerInterviewType.Telephone:
            return IconConstants.TelephoneInterview;
        case JobWorkerInterviewType.Online:
            return IconConstants.OnlineInterview;
        case JobWorkerInterviewType.InPerson:
            return IconConstants.InPersonInterview;
        default:
            return "Unknown";
    }
} 